import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  connect() {
    this.scrollToCommentsWhenDeepLinkingToComment();
  }

  scrollToCommentsWhenDeepLinkingToComment() {
    if(window.location.hash.match(/#comment-(\d+)/)) {
      document.querySelector('#comments').scrollIntoView();
    }
  }
}
